const FILTER_TYPES = {
  'AFFAMÉ': 1,
  'AFFREUX': 3,
  'BALLONNÉ': 2,
  'BLESSÉ': 7,
  'ENRHUMÉ': 6,
  'NAUSÉEUX': 8,
  'RAPLAPLA': 0,
  'STRESSÉ': 5,
  'SUANT': 4
}

export default FILTER_TYPES



/** WEBPACK FOOTER **
 ** ./src/components/Home/classes/FilterTypes.js
 **/